// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Link from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => {
    return {
        homeUrl: getPageLinkByPageType(state, "HomePage")?.url,
    };
};

const mapDispatchToProps = {};

type Props = HiddenProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const ContinueShoppingLink: React.FC<Props> = props => {
    const { history, homeUrl } = props;
    return (
        <Hidden {...props}>
            <Link
                typographyProps={{
                    weight: fontConfig.weight.semiBold,
                    lineHeight: fontConfig.lineHeight.singleLineSmall,
                    css: css`
                        color: ${getColor("secondary.main")};
                        opacity: 0.7;
                    `,
                }}
                href={homeUrl}
            >
                {translate("Continue Shopping")}
            </Link>
        </Hidden>
    );
};

export default withHistory(connect(mapStateToProps, mapDispatchToProps)(ContinueShoppingLink));
